import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

const vendorMasterAdapter = createEntityAdapter({});

const initialState = vendorMasterAdapter.getInitialState();

export const vendorMasterApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getVendorMaster: builder.query({
            query: () => ({
                url: '/vendormaster',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError;
                },
            }),
            transformResponse: responseData => {
                const loadedVendorMaster = responseData.map(vendor => {
                    vendor.id = vendor._id;
                    return vendor;
                });
                return vendorMasterAdapter.setAll(initialState, loadedVendorMaster);
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'VENDOR_MASTER', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'VENDOR_MASTER', id }))
                    ];
                } else {
                    return [{ type: 'VENDOR_MASTER', id: 'LIST' }];
                }
            }
        }),
        addNewVendorMaster: builder.mutation({
            query: initialUserData => ({
                url: '/vendormaster',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'VENDOR_MASTER', id: "LIST" }
            ]
        }),
        updateVendorMaster: builder.mutation({
            query: initialUserData => ({
                url: '/vendormaster',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'VENDOR_MASTER', id: arg.id }
            ]
        }),        
        deleteVendorMaster: builder.mutation({
            query: ({ id }) => ({
                url: "/vendormaster",
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'VENDOR_MASTER', id: arg.id }
            ]
        }),
    }),
});

export const {
    useGetVendorMasterQuery,
    useAddNewVendorMasterMutation,
    useUpdateVendorMasterMutation,
    useDeleteVendorMasterMutation, 
} = vendorMasterApiSlice;

export const selectVendorMasterResult = vendorMasterApiSlice.endpoints.getVendorMaster.select();

const selectVendorMasterData = createSelector(
    selectVendorMasterResult,
    vendorMasterResult => vendorMasterResult.data
);

export const {
    selectAll: selectAllVendorMaster,
    selectById: selectVendorMasterById,
    selectIds: selectVendorMasterIds
} = vendorMasterAdapter.getSelectors(state => selectVendorMasterData(state) ?? initialState);
